import React, { useState } from 'react';
import { cadastrarAdmin } from '../../services/api';
import styles from './CadastroAdmin.module.css';

export default function CadastroAdmin() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [status, setStatus] = useState({ tipo: '', mensagem: '' });
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (senha !== confirmarSenha) {
      setStatus({ tipo: 'erro', mensagem: 'As senhas nao coincidem.' });
      return;
    }

    setEnviando(true);
    setStatus({ tipo: '', mensagem: '' });

    try {
      await cadastrarAdmin(email, senha);
      setStatus({ tipo: 'sucesso', mensagem: 'Novo admin cadastrado com sucesso.' });
      setEmail('');
      setSenha('');
      setConfirmarSenha('');
    } catch (err) {
      setStatus({ tipo: 'erro', mensagem: err.message || 'Erro ao cadastrar admin.' });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <section className={`${styles.container} ui-surface`}>
      <h2>Cadastrar Novo Admin</h2>
      <p className={styles.subtitulo}>Somente contas com papel admin podem usar esta acao.</p>

      <form className={styles.form} onSubmit={handleSubmit}>
        <label>Email *</label>
        <input
          className="ui-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Senha *</label>
        <input
          className="ui-input"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          required
        />

        <label>Confirmar senha *</label>
        <input
          className="ui-input"
          type="password"
          value={confirmarSenha}
          onChange={(e) => setConfirmarSenha(e.target.value)}
          required
        />

        {status.mensagem && (
          <p className={status.tipo === 'sucesso' ? styles.sucesso : styles.erro}>
            {status.mensagem}
          </p>
        )}

        <button className="ui-button-primary" type="submit" disabled={enviando}>
          {enviando ? 'Salvando...' : 'Cadastrar Admin'}
        </button>
      </form>
    </section>
  );
}
